import { on } from '@ngrx/store';
import { updateRemarksSection } from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';

export function updateRemarksSectionReducer(
    state: Readonly<FormState>,
    props: { xmlId: string; newValue: string },
): Readonly<FormState> {
    return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore --- @TEO can you please check that?
        participantCopies: {
            ...state.participantCopies,
            [state.selectedParticipantCopyId]: {
                ...state.participantCopies[state.selectedParticipantCopyId],
                remarksSection: {
                    ...state.participantCopies[state.selectedParticipantCopyId].remarksSection,
                    value: props.newValue,
                },
            },
        },
    };
}

export const remarksSectionReducer = [
    on<FormState, Array<typeof updateRemarksSection>>(updateRemarksSection, updateRemarksSectionReducer),
];
